import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { useGetJobsRankingQuery, useGetMediacoreDevRankingQuery } from '@apis/mediacore/owner'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'

const FrequentSearch3 = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    titleElement,
    paragraphElement,
    paragraph,
    global_data,
    backgroundColor,
    backgroundHexa,
    titleColor,
    titleHexa,
    alignCenter,
    underlineMode,
    placeholder,
    showJobs,
    subtitle,
    spanText,
  } = props
  const { divisionPath } = global_data

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const { data, isLoading } = useGetMediacoreDevRankingQuery()

  const { data: jobsData, isLoading: isLoadingJobs } = useGetJobsRankingQuery()

  function emptyValues() {
    let value = 4
    if (data) {
      for (const item of data) {
        if (item?.values.length === 0) {
          value--
        }
      }
    }
    return value
  }

  return isMounted && data && data?.length > 0 ? (
    <section
      style={{ backgroundColor: backgroundHexa }}
      className={`fp-dev ${
        !isLoading && data?.length === 0 ? 'd-none' : ''
      } ${backgroundColor} p-y-config`}
    >
      <Container fluid>
        <Row>
          <Col lg={alignCenter ? 12 : 2}>
            <ElementHTML
              elementType={titleElement || 'h2'}
              children={title || 'Búsquedas'}
              className={`pb-lg-5 mb-lg-4 mb-lg-5 mb-0 ${
                alignCenter ? 'text-center' : 'text-start'
              } ${titleColor}`}
              style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
            />
          </Col>
          <Col lg={alignCenter ? 12 : 10}>
            <ElementHTML
              elementType={paragraphElement || 'p'}
              children={paragraph || ''}
              className={`${alignCenter ? 'text-center' : 'text-start'} text-lg-start`}
            />
          </Col>
        </Row>
        <Row
          className={`${
            alignCenter ? 'text-start' : 'text-center'
          } mx-auto px-0 px-lg-auto mt-lg-0 mt-4 `}
        >
          <Col
            lg={alignCenter ? 8 : { span: 10, offset: 2 }}
            className={alignCenter ? 'mx-auto' : ''}
          >
            <Row className={emptyValues() !== 4 ? 'justify-content-center' : ''}>
              {data?.map((rank) => (
                <Col
                  className={'mt-lg-2 mt-5 ' + (rank.values.length === 0 && 'd-none')}
                  lg={showJobs ? 3 : 4}
                >
                  <h5
                    style={underlineMode ? { textDecoration: 'underline' } : {}}
                    className="mb-3"
                  >
                    {' '}
                    {placeholder ?? 'Emprendimientos'} en{' '}
                    {rank.label
                      ?.toLowerCase()
                      .split('en ')
                      .map((text) => text.charAt(0).toUpperCase() + text.slice(1))}
                  </h5>
                  {rank?.values?.slice(0, 3)?.map((dev) => (
                    <p style={{ fontStyle: 'inherit', fontSize: 'inherit' }}>
                      <Link
                        className="w-100 d-block"
                        to={
                          (divisionPath ?? '') +
                          '/emprendimiento/' +
                          dev?.name?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
                          '/' +
                          dev!.id
                        }
                      >
                        {`${alignCenter ? '' : 'Emprendimiento'} ${dev?.name}`}
                      </Link>
                    </p>
                  ))}
                </Col>
              ))}
              {showJobs && !isLoadingJobs && (
                <Col
                  className={'mt-lg-2 mt-5 ' + (jobsData?.length === 0 && 'd-none')}
                  lg={3}
                >
                  <h5
                    style={underlineMode ? { textDecoration: 'underline' } : {}}
                    className="mb-3"
                  >
                    {subtitle ?? 'Posiciones'}
                  </h5>
                  {jobsData?.slice(0, 3)?.map((rank) => (
                    <p style={{ fontStyle: 'inherit', fontSize: 'inherit' }}>
                      <Link
                        className="w-100 d-block"
                        to={spanText ?? '/posiciones'}
                      >
                        {rank?.label}
                      </Link>
                    </p>
                  ))}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  ) : (
    <></>
  )
}

export default FrequentSearch3
